import React from "react";
import { useTranslation } from "react-i18next";
import { motion, useReducedMotion } from "framer-motion";
import { FiCheck, FiMail, FiSend } from "react-icons/fi";
import { Button } from "../../ui/Button";
import { useNewsletterSubscribe } from "../../hooks/useNewsletterSubscribe";
import * as D from "./Farms.desktop.styled";

const FarmNewsletterDesktop = ({ onSuccess, onError }) => {
  const { t } = useTranslation();
  const reduceMotion = useReducedMotion();
  const { email, setEmail, submit, submitting } = useNewsletterSubscribe({
    source: "farms",
    onSuccess,
    onError,
  });

  const perks = [
    t("farms.subscribe.perk1", {
      defaultValue: "Weekly fresh drops straight to your inbox",
    }),
    t("farms.subscribe.perk2", {
      defaultValue: "Early access to seasonal baskets",
    }),
    t("farms.subscribe.perk3", {
      defaultValue: "Unsubscribe any time — no spam",
    }),
  ];

  return (
    <D.NewsletterSection>
      <D.Container>
        <D.NewsletterPanel
          as={motion.div}
          initial={{ opacity: 0, y: reduceMotion ? 0 : 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: reduceMotion ? 0 : 0.6, ease: [0.22, 1, 0.36, 1] }}
        >
          <D.NewsletterCopy>
            <D.SectionKicker>
              <FiMail aria-hidden="true" style={{ marginRight: 6 }} />
              {t("farms.subscribe.kicker", { defaultValue: "Newsletter" })}
            </D.SectionKicker>
            <D.NewsletterTitle>
              {t("farms.subscribe.section_title", {
                defaultValue: "Stay Updated",
              })}
            </D.NewsletterTitle>
            <D.NewsletterBody>
              {t("farms.subscribe.subscribe_text", {
                defaultValue:
                  "Subscribe to our newsletter for the latest updates on fresh produce!",
              })}
            </D.NewsletterBody>
            <D.NewsletterPerks>
              {perks.map((perk) => (
                <D.NewsletterPerk key={perk}>
                  <FiCheck size={16} aria-hidden="true" />
                  {perk}
                </D.NewsletterPerk>
              ))}
            </D.NewsletterPerks>
          </D.NewsletterCopy>

          <D.NewsletterForm onSubmit={submit}>
            <D.NewsletterField>
              <FiMail size={18} aria-hidden="true" />
              <D.NewsletterInput
                type="email"
                autoComplete="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder={t("farms.subscribe.email_placeholder", {
                  defaultValue: "Enter your email",
                })}
                aria-label={t("farms.subscribe.email_placeholder", {
                  defaultValue: "Enter your email",
                })}
              />
            </D.NewsletterField>
            <Button
              type="submit"
              variant="primary"
              iconRight={<FiSend aria-hidden="true" />}
              fullWidth
              disabled={submitting}
            >
              {submitting
                ? t("farms.subscribe.subscribing", { defaultValue: "Subscribing…" })
                : t("farms.subscribe.subscribe_button", { defaultValue: "Subscribe" })}
            </Button>
            <D.NewsletterNote>
              {t("farms.subscribe.privacy", {
                defaultValue:
                  "We respect your privacy. Read more in our terms.",
              })}
            </D.NewsletterNote>
          </D.NewsletterForm>
        </D.NewsletterPanel>
      </D.Container>
    </D.NewsletterSection>
  );
};

export default FarmNewsletterDesktop;
